import React from 'react';
import { Reveal } from './Reveal';
import { CrossIcon } from './icons/Icons';
const fears = ['Miedo a pedir algo en un restaurante', 'Miedo a que el café de la mañana te arruine el día', 'Miedo a que ese ardor se convierta en una úlcera… o algo peor'];
export function AgitationSection() {
  return <section className="w-full bg-[#f7f4ec] py-16 sm:py-20" data-id="element-19">
      <div className="mx-auto max-w-3xl px-5" data-id="element-20">
        <Reveal data-id="element-21">
          <h2 className="text-center font-display text-3xl font-extrabold leading-tight text-[#1f2a22] sm:text-4xl" data-id="element-22">
            Vivir con gastritis no es solo tener dolor;
            <br data-id="element-23" />
            <span className="text-[#7a1e12]" data-id="element-24">es vivir con miedo.</span>
          </h2>
        </Reveal>

        <div className="mx-auto mt-10 grid max-w-xl gap-3" data-id="element-25">
          {fears.map((fear, i) => <Reveal key={fear} delay={i * 0.08} data-id="element-26">
              <div className="flex items-start gap-3 rounded-xl border border-[#7a1e12]/10 bg-white px-4 py-3.5 shadow-sm" data-id="element-27">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#7a1e12]/10 text-[#7a1e12]" data-id="element-28">
                  <CrossIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-29" />
                </span>
                <p className="text-base text-[#3d4a40]" data-id="element-30">{fear}</p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.2} data-id="element-31">
          <div className="mx-auto mt-10 max-w-2xl space-y-4 text-center text-lg leading-relaxed text-[#3d4a40]" data-id="element-32">
            <p data-id="element-33">
              Te han dicho que{' '}
              <span className="italic" data-id="element-34">“debes vivir con eso”</span>, que{' '}
              <span className="italic" data-id="element-35">“es el estrés”</span> o que simplemente{' '}
              <span className="italic" data-id="element-36">“evites el picante”</span>. Pero mientras
              sigas tapando el síntoma con químicos, tu estómago se sigue
              desgastando.
            </p>
            <p className="font-display text-xl font-bold text-[#1f2a22]" data-id="element-37">
              El costo de no hacer nada no es solo el ardor de hoy…
              <br data-id="element-38" />
              <span className="text-[#7a1e12]" data-id="element-39">
                es el daño crónico de mañana.
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}